'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var multihashing = require('multihashing-async');

var errcode = require('err-code');

var _require = require('buffer'),
    Buffer = _require.Buffer;
/**
 * Validator for publick key records.
 * Verifies that the passed in record value is the PublicKey
 * that matches the passed in key.
 * If validation fails the returned Promise will reject with the error.
 *
 * @param {Buffer} key - A valid key is of the form `'/pk/<keymultihash>'`
 * @param {Buffer} publicKey - The public key to validate against (protobuf encoded).
 * @returns {Promise}
 */


var validatePublicKeyRecord = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, publicKey) {
    var prefix, keyhash, publicKeyHash;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (Buffer.isBuffer(key)) {
              _context.next = 2;
              break;
            }

            throw errcode(new Error('"key" must be a Buffer'), 'ERR_INVALID_RECORD_KEY_NOT_BUFFER');

          case 2:
            if (!(key.length < 5)) {
              _context.next = 4;
              break;
            }

            throw errcode(new Error('invalid public key record'), 'ERR_INVALID_RECORD_KEY_TOO_SHORT');

          case 4:
            prefix = key.slice(0, 4).toString();

            if (!(prefix !== '/pk/')) {
              _context.next = 7;
              break;
            }

            throw errcode(new Error('key was not prefixed with /pk/'), 'ERR_INVALID_RECORD_KEY_BAD_PREFIX');

          case 7:
            keyhash = key.slice(4);
            _context.next = 10;
            return multihashing(publicKey, 'sha2-256');

          case 10:
            publicKeyHash = _context.sent;

            if (keyhash.equals(publicKeyHash)) {
              _context.next = 13;
              break;
            }

            throw errcode(new Error('public key does not match passed in key'), 'ERR_INVALID_RECORD_HASH_MISMATCH');

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validatePublicKeyRecord(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = {
  func: validatePublicKeyRecord,
  sign: false
};